import type { FireflyTertiaryButtonMenuItem } from '@equip.health/ui';
import { isEmpty } from 'lodash';

import { ActivityWith } from '~/lib/util/classes/groupClasses.util';

export const NoteFormDefaultSessionLink: FireflyTertiaryButtonMenuItem = {
  node: 'No session Link',
  label: 'No session Link',
};

// If appointment details are available, then prefill the activity
export const fillActivityWith = (
  appointmentDetails: AppointmentDetailResponse,
  activityWithReasons: NoteMultiSelectOption[],
) => {
  const activityWith: NoteMultiSelectOption[] = [];

  if (!isEmpty(appointmentDetails?.patient)) {
    const matchEntry = activityWithReasons.find(
      (e) => e.value.toLowerCase() === ActivityWith.PATIENT,
    );
    if (matchEntry) {
      activityWith.push(matchEntry);
    }
  }

  if (!isEmpty(appointmentDetails?.providerAttendees)) {
    const matchEntry = activityWithReasons.find(
      (e) => e.value.toLowerCase() === ActivityWith.PROVIDER,
    );
    if (matchEntry) {
      activityWith.push(matchEntry);
    }
  }

  if (!isEmpty(appointmentDetails?.supportAttendees)) {
    const matchEntry = activityWithReasons.find(
      (e) => e.value.toLowerCase() === ActivityWith.CARER,
    );
    if (matchEntry) {
      activityWith.push(matchEntry);
    }
  }
  return activityWith;
};
